"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = exports.Text = exports.Anchor = exports.Clickabile = exports.ObliqueLine = exports.Bytes = exports.Empathize = exports.Percentage = exports.Color = exports.Money = exports.Date = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var React = __importStar(require("react"));
var ndValue = function () { return (0, jsx_runtime_1.jsx)(React.Fragment, { children: "ND" }); };
var Date = function (_a) {
    var date = _a.date, _b = _a.format, format = _b === void 0 ? 'DD/MM/YYYY' : _b;
    return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: null === date ? '-' : (0, moment_timezone_1.default)(date).locale('it').format(format) }));
};
exports.Date = Date;
var Money = function (_a) {
    var amount = _a.amount, _b = _a.fractionDigits, fractionDigits = _b === void 0 ? 2 : _b;
    return typeof amount === 'number' ? ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: ["\u20AC", ' ', amount
                .toFixed(fractionDigits)
                .replace(/\./g, ',')
                .replace(/\B(?=(\d{3})+(?!\d))/g, '.')] })) : (ndValue());
};
exports.Money = Money;
var Color = function (props) { return (0, jsx_runtime_1.jsx)("span", __assign({ className: "field-formatter color ".concat(props.color) }, { children: props.children })); };
exports.Color = Color;
var buildPercentage = function (props) {
    var scale = typeof props.scale !== undefined ? props.scale : 2;
    var percentage = (props.total ? (props.amount / props.total) * 100 : props.amount).toFixed(scale);
    return (0, jsx_runtime_1.jsxs)(React.Fragment, { children: [percentage.toString().replace(/\./g, ','), "%"] });
};
var Percentage = function (props) { return (typeof props.amount === 'number' ? buildPercentage(props) : ndValue()); };
exports.Percentage = Percentage;
var Empathize = function (props) { return (0, jsx_runtime_1.jsx)("span", __assign({ className: "field-formatter empathize" }, { children: props.children })); };
exports.Empathize = Empathize;
var Bytes = function (props) {
    if (props.size === 0) {
        return (0, jsx_runtime_1.jsx)(React.Fragment, { children: "0 Byte" });
    }
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    var i = Math.floor(Math.log(props.size) / Math.log(1024));
    return (0, jsx_runtime_1.jsx)(React.Fragment, { children: "".concat(Math.round((props.size / Math.pow(1024, i)) * 100) / 100, " ").concat(sizes[i]) });
};
exports.Bytes = Bytes;
var ObliqueLine = function (props) {
    return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", { children: props.children }), (0, jsx_runtime_1.jsx)("div", { className: "field-formatter-diagonal-line" })] }));
};
exports.ObliqueLine = ObliqueLine;
var Clickabile = function (props) {
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "field-formatter-clickabile", onClick: props.onClick }, { children: props.children })));
};
exports.Clickabile = Clickabile;
var Anchor = function (props) {
    return ((0, jsx_runtime_1.jsx)("a", __assign({ rel: "noopener", className: "field-formatter-anchor", href: props.href, target: props.target }, { children: props.children })));
};
exports.Anchor = Anchor;
var Text = function (props) {
    var fontFamily = props.fontFamily ? props.fontFamily : 'std';
    return ((0, jsx_runtime_1.jsx)("span", __assign({ className: (0, clsx_1.default)('field-formatter-text', "font-size-".concat(props.fontSize), "font-weight-".concat(props.fontWeight), "font-family-".concat(fontFamily)) }, { children: props.children })));
};
exports.Text = Text;
var Icon = function (props) {
    return (0, jsx_runtime_1.jsx)("span", __assign({ className: (0, clsx_1.default)("field-formatter-icon", props.icon) }, { children: props.children }));
};
exports.Icon = Icon;
//# sourceMappingURL=Formatter.js.map